/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsOptimizeWorkTypeSchemeRoute } from '@jira/router-routes__admin-pages-fields-routes/src/globalSettingsOptimizeWorkTypeSchemeRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	OptimizeWorkTypeSchemePage,
	LazyOptimizeWorkTypeSchemePagePage,
} from './ui/spa/admin-pages/fields/optimize-work-type-scheme-page/index.tsx';

export const globalSettingsOptimizeWorkTypeSchemeRouteEntry: Route = createEntry(
	globalSettingsOptimizeWorkTypeSchemeRoute,
	() => ({
		group: 'global-settings',

		// eslint-disable-next-line no-restricted-syntax
		component: OptimizeWorkTypeSchemePage,

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyOptimizeWorkTypeSchemePagePage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
